<template>
    <section class="page-search-results">
        <div class="container">
            <div class="row">
                <div class="favorites-card-list card-element-list" :class="{'list-mode' : isList}" id="target-list-1" style="position:relative">

                    <slot></slot>

                    <card v-for="item in bookmarks" :key="item.identifier"
                          :id="item.identifier"
                          :content="isList ? item.listData : item.gridData"
                          :digitalized="item.digitalized"
                          :in-sede="item.inSede"
                          :link="item.link"
                          :image-path="item.image ? item.image.href : ''"
                          :tag="item.tag"
                          @remove-item="$emit('remove-item', $event)" />

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Card from './Card'

    export default {
        name: "BookmarksContainer",
        components: {
            Card
        },
        props: {
            bookmarks: Array,
            isList: Boolean
        }
    }
</script>

<style scoped>

</style>